var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8548_27240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.9996C15.5228 19.9996 20 15.5225 20 9.99963C20 4.47679 15.5228 -0.000366211 10 -0.000366211C4.47715 -0.000366211 0 4.47679 0 9.99963C0 15.5225 4.47715 19.9996 10 19.9996Z",
    fill: "#FFB703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.1775C13.9642 17.1775 17.1777 13.9639 17.1777 9.99976C17.1777 6.0356 13.9642 2.82202 10 2.82202C6.03585 2.82202 2.82227 6.0356 2.82227 9.99976C2.82227 13.9639 6.03585 17.1775 10 17.1775Z",
    fill: "#FFCC29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 17.1774C13.9642 17.1774 17.1777 13.9638 17.1777 9.99963C17.1777 6.03548 13.9642 2.8219 10 2.8219C6.03585 2.8219 2.82227 6.03548 2.82227 9.99963C2.82227 13.9638 6.03585 17.1774 10 17.1774Z",
    stroke: "#F99300",
    strokeWidth: 1.2625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3325 18.3022C14.9734 17.638 16.3785 16.499 17.3678 15.0311C18.3571 13.5632 18.8855 11.8333 18.8853 10.0631",
    stroke: "#FFCC29",
    strokeWidth: 0.757422,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.55664 2.3046C6.90672 1.52296 8.43958 1.11245 9.99961 1.11476",
    stroke: "#FFCC29",
    strokeWidth: 0.757422,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5293 5.18621C2.96204 4.51584 3.48284 3.90663 4.07773 3.37488",
    stroke: "#FFCC29",
    strokeWidth: 0.757422,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19576 14.2516C1.48427 12.9476 1.11244 11.4855 1.11451 10",
    stroke: "#FFCC29",
    strokeWidth: 0.757422,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8566 9.28355L10.1046 6.74801C10.093 6.73101 10.0774 6.7171 10.0591 6.7075C10.0409 6.69789 10.0206 6.69287 9.99996 6.69287C9.97934 6.69287 9.95904 6.69789 9.9408 6.7075C9.92256 6.7171 9.90693 6.73101 9.89527 6.74801L8.14332 9.28355C8.12654 9.30801 8.10174 9.32585 8.07322 9.33398C8.04469 9.34211 8.01422 9.34002 7.98707 9.32809L5.50113 8.22379C5.47893 8.21404 5.45442 8.21081 5.43046 8.21447C5.40649 8.21813 5.38407 8.22854 5.3658 8.24447C5.34753 8.26041 5.33417 8.28121 5.32728 8.30446C5.3204 8.3277 5.32027 8.35243 5.32691 8.37574L6.76832 13.3117C6.77601 13.3382 6.79209 13.3614 6.81414 13.378C6.83619 13.3945 6.86301 13.4035 6.89058 13.4035H13.1097C13.1373 13.4035 13.1641 13.3945 13.1862 13.378C13.2082 13.3614 13.2243 13.3382 13.232 13.3117L14.6734 8.37574C14.68 8.35243 14.6799 8.3277 14.673 8.30446C14.6661 8.28121 14.6528 8.26041 14.6345 8.24447C14.6162 8.22854 14.5938 8.21813 14.5698 8.21447C14.5459 8.21081 14.5214 8.21404 14.4992 8.22379L12.0132 9.32809C11.986 9.3399 11.9555 9.34191 11.927 9.3338C11.8984 9.32568 11.8735 9.30793 11.8566 9.28355Z",
    fill: "#F99300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8548_27240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCredit);
export default __webpack_public_path__ + "static/media/icon-credit.889a05ab9caeaf959f936b556b63e199.svg";
export { ForwardRef as ReactComponent };